export enum IconEnum {
    AIDA = 'ic_aida',
    LIGHT = 'ic_light',
    LOGO =  'logo_small',
    RATE_DISAPPOINTING = 'ic_disappointing',
    RATE_DISAPPOINTING_C = 'ic_disappointing_selected',
    RATE_NOT_GOOD = 'ic_nogood',
    RATE_NOT_GOOD_C = 'ic_nogood_colour',
    RATE_OK = 'ic_ok',
    RATE_OK_C = 'ic_ok_colour',
    RATE_GOOD = 'ic_good',
    RATE_GOOD_C = 'ic_good_colour',
    RATE_EXTRAORDINARY = 'ic_satisfied',
    RATE_EXTRAORDINARY_C = 'ic_satisfied_colour',
}

export enum ImgEnum {
    AIDA_SMALL = 'aida',
    AIDA = 'aida@2x',
    ARROW_RIGHT = 'arrow-right@2x',
    CHECKMARK = 'ic_checkmark@2x',
    SECRETARY = 'secretary-outbound_email@2x'
    
}

export type SaAssets = {
    name: IconEnum | ImgEnum;
    filename: string;
    brandSpecific?: boolean;
}

export const IMG: SaAssets[] = [
    {
        name: ImgEnum.AIDA,
        filename: `${ImgEnum.AIDA}.png`,
    },
    {
        name: ImgEnum.ARROW_RIGHT,
        filename: `${ImgEnum.ARROW_RIGHT}.png`,
    },
    {
        name: ImgEnum.CHECKMARK,
        filename: `${ImgEnum.CHECKMARK}.png`,
    },
    {
        name: ImgEnum.SECRETARY,
        filename: `${ImgEnum.SECRETARY}.png`,
        brandSpecific: true
    },
];

export const ICONS: SaAssets[] = [
    {
        name: IconEnum.AIDA,
        filename: `${IconEnum.AIDA}.svg`,
    }, {
        name: IconEnum.LIGHT,
        filename: `${IconEnum.LIGHT}.svg`,
    },
    {
        name: IconEnum.LOGO,
        filename: `${IconEnum.LOGO}.svg`,
        brandSpecific: true,
    }
];

